var _path, _path2, _path3, _g, _path4, _g2, _g3, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJpgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 94,
    viewBox: "0 0 84 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8486_54889",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 84,
    height: 94
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.2059 94H6.79412C3.04183 94 0 90.9939 0 87.2857V6.71429C0 3.00609 3.04183 0 6.79412 0H52.5L84 31.1299V87.2857C84 90.9939 80.9582 94 77.2059 94Z",
    fill: "url(#paint0_linear_8486_54889)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8486_54889)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2059 94H6.79412C3.04183 94 0 90.9939 0 87.2857V6.71429C0 3.00609 3.04183 0 6.79412 0H52.5L84 31.1299V87.2857C84 90.9939 80.9582 94 77.2059 94Z",
    fill: "url(#paint1_linear_8486_54889)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2059 94H6.79412C3.04183 94 0 90.9939 0 87.2857V6.71429C0 3.00609 3.04183 0 6.79412 0H52.5L84 31.1299V87.2857C84 90.9939 80.9582 94 77.2059 94Z",
    fill: "#F2A950"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("line", {
    x1: 22.5439,
    y1: 36.4218,
    x2: 61.4557,
    y2: 36.4218,
    stroke: "white",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.5439,
    y1: 45.5774,
    x2: 61.4557,
    y2: 45.5774,
    stroke: "white",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.5439,
    y1: 54.733,
    x2: 61.4557,
    y2: 54.733,
    stroke: "white",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.5439,
    y1: 63.8895,
    x2: 61.4557,
    y2: 63.8895,
    stroke: "white",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.5439,
    y1: 73.0452,
    x2: 61.4557,
    y2: 73.0452,
    stroke: "white",
    strokeWidth: 12
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8486_54889",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 84,
    height: 94
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2059 94H6.79412C3.04183 94 0 90.9939 0 87.2857V6.71429C0 3.00609 3.04183 0 6.79412 0H52.5L84 31.1299V87.2857C84 90.9939 80.9582 94 77.2059 94Z",
    fill: "#F2A950"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8486_54889)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.08,
    cx: -8.49258,
    cy: -1.98408,
    rx: 69.0221,
    ry: 65.4643,
    fill: "#F2A950"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.08,
    cx: -8.49213,
    cy: -1.98359,
    rx: 43.3897,
    ry: 41.0487,
    fill: "#F2A950"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8486_54889)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84 31.1299H74.5C62.3497 31.1299 52.5 21.2801 52.5 9.12988V0L84 31.1299Z",
    fill: "#CC9249"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.598 58.84V69.682C31.598 71.7447 31.0173 73.3567 29.856 74.518C28.6947 75.6793 27.048 76.26 24.916 76.26C23.3907 76.26 22.1513 75.9827 21.198 75.428C20.2447 74.8733 19.586 74.0933 19.222 73.088C18.858 72.0827 18.7887 70.93 19.014 69.63L22.498 69.006C22.29 70.5313 22.3853 71.632 22.784 72.308C23.1827 72.984 23.9193 73.322 24.994 73.322C26.1207 73.322 26.9007 72.9753 27.334 72.282C27.7847 71.5887 28.01 70.5573 28.01 69.188V58.84H31.598ZM43.0025 58.84C44.3198 58.84 45.4465 59.0653 46.3825 59.516C47.3185 59.9493 48.0378 60.582 48.5405 61.414C49.0605 62.2287 49.3205 63.2167 49.3205 64.378C49.3205 65.5393 49.0605 66.536 48.5405 67.368C48.0378 68.1827 47.3185 68.8153 46.3825 69.266C45.4465 69.6993 44.3198 69.916 43.0025 69.916H39.3885V76H35.8005V58.84H43.0025ZM42.4565 67.082C43.5311 67.082 44.3371 66.8567 44.8745 66.406C45.4118 65.938 45.6805 65.262 45.6805 64.378C45.6805 63.4767 45.4118 62.8007 44.8745 62.35C44.3371 61.8993 43.5311 61.674 42.4565 61.674H39.3885V67.082H42.4565ZM59.655 76.26C58.0777 76.26 56.691 75.9133 55.495 75.22C54.3164 74.5267 53.3977 73.5213 52.739 72.204C52.0804 70.8867 51.751 69.3007 51.751 67.446C51.751 65.6087 52.0977 64.0313 52.791 62.714C53.4844 61.3793 54.4637 60.3567 55.729 59.646C57.0117 58.9353 58.4937 58.58 60.175 58.58C62.0297 58.58 63.529 58.9267 64.673 59.62C65.817 60.296 66.727 61.3533 67.403 62.792L64.075 64.222C63.7977 63.3033 63.321 62.6273 62.645 62.194C61.9864 61.7433 61.1717 61.518 60.201 61.518C59.2304 61.518 58.3897 61.752 57.679 62.22C56.9684 62.6707 56.4224 63.338 56.041 64.222C55.6597 65.0887 55.469 66.1547 55.469 67.42C55.469 68.72 55.651 69.8207 56.015 70.722C56.379 71.606 56.9164 72.2733 57.627 72.724C58.355 73.1573 59.2477 73.374 60.305 73.374C60.877 73.374 61.4057 73.3047 61.891 73.166C62.3937 73.0273 62.827 72.8193 63.191 72.542C63.555 72.2647 63.841 71.9093 64.049 71.476C64.257 71.0427 64.361 70.54 64.361 69.968V69.578H59.863V66.952H67.455V76H64.933L64.673 72.256L65.297 72.698C64.9157 73.842 64.2397 74.726 63.269 75.35C62.3157 75.9567 61.111 76.26 59.655 76.26Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8486_54889",
    x: 29.5,
    y: -24,
    width: 81.5,
    height: 81.1299,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.33 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8486_54889"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8486_54889",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8486_54889",
    x1: 42,
    y1: 0,
    x2: 42,
    y2: 94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E85555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8486_54889",
    x1: 0,
    y1: 0,
    x2: 96.4083,
    y2: 78.8235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34A0A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85C894"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJpgIcon);
export default __webpack_public_path__ + "static/media/jpg_icon.7bdeffc8a396aa8ab5126544d6bff479.svg";
export { ForwardRef as ReactComponent };